import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Button,
  Box,
  Menu,
  MenuItem,
} from '@mui/material';
import {
  Brightness4,
  Brightness7,
  Logout,
  AccountCircle,
  Dashboard,
  Folder,
  Map,
  TrendingUp,
  Storage,
  BarChart,
  Key,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useTheme } from '../../context/ThemeContext';

export const Header: React.FC = () => {
  const { user, logout } = useAuth();
  const { mode, toggleTheme } = useTheme();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleChangePassword = () => {
    handleMenuClose();
    navigate('/change-password');
  };

  return (
    <AppBar position="static" elevation={2}>
      <Toolbar>
        <Box
          component="img"
          src="/kesmarki_logo_small.png"
          alt="Logo"
          sx={{
            height: 40,
            mr: 2,
            cursor: 'pointer',
          }}
          onClick={() => navigate('/dashboard')}
        />
        <Typography
          variant="h6"
          component="div"
          sx={{
            flexGrow: 1,
            cursor: 'pointer',
            fontWeight: 600,
            letterSpacing: '0.5px'
          }}
          onClick={() => navigate('/dashboard')}
        >
          InValue
        </Typography>

        {user && (
          <>
            <Button
              color="inherit"
              onClick={() => navigate('/dashboard')}
              startIcon={<Dashboard sx={{ fontSize: 20 }} />}
              sx={{ mx: 0.5, fontWeight: 500, fontSize: '0.9rem' }}
            >
              Dashboard
            </Button>
            <Button
              color="inherit"
              onClick={() => navigate('/auction-files')}
              startIcon={<Folder sx={{ fontSize: 20 }} />}
              sx={{ mx: 0.5, fontWeight: 500, fontSize: '0.9rem' }}
            >
              Aukciós Fájlok
            </Button>
            <Button
              color="inherit"
              onClick={() => navigate('/mappings')}
              startIcon={<Map sx={{ fontSize: 20 }} />}
              sx={{ mx: 0.5, fontWeight: 500, fontSize: '0.9rem' }}
            >
              Mapping-ek
            </Button>
            <Button
              color="inherit"
              onClick={() => navigate('/predictions')}
              startIcon={<TrendingUp sx={{ fontSize: 20 }} />}
              sx={{ mx: 0.5, fontWeight: 500, fontSize: '0.9rem' }}
            >
              Előrejelzések
            </Button>
            <Button
              color="inherit"
              onClick={() => navigate('/actual-data-sources')}
              startIcon={<Storage sx={{ fontSize: 20 }} />}
              sx={{ mx: 0.5, fontWeight: 500, fontSize: '0.9rem' }}
            >
              Tényadatok
            </Button>
            <Button
              color="inherit"
              onClick={() => navigate('/prediction-comparisons')}
              startIcon={<BarChart sx={{ fontSize: 20 }} />}
              sx={{ mx: 0.5, fontWeight: 500, fontSize: '0.9rem' }}
            >
              Terv/Tény
            </Button>
            <Box sx={{ flexGrow: 1 }} />
            <IconButton
              color="inherit"
              onClick={handleMenuOpen}
              title="Profil menü"
              sx={{ mr: 1 }}
            >
              <AccountCircle />
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
            >
              <MenuItem disabled>
                <Typography variant="body2" sx={{ fontWeight: 600 }}>
                  {user.username}
                </Typography>
              </MenuItem>
              <MenuItem onClick={handleChangePassword}>
                <Key fontSize="small" sx={{ mr: 1 }} />
                Jelszó változtatás
              </MenuItem>
              <MenuItem onClick={handleLogout}>
                <Logout fontSize="small" sx={{ mr: 1 }} />
                Kijelentkezés
              </MenuItem>
            </Menu>
            <IconButton
              color="inherit"
              onClick={toggleTheme}
              title={mode === 'dark' ? 'Világos mód' : 'Sötét mód'}
            >
              {mode === 'dark' ? <Brightness7 /> : <Brightness4 />}
            </IconButton>
          </>
        )}
      </Toolbar>
    </AppBar>
  );
};

